import { render, staticRenderFns } from "./CCLILogo.vue?vue&type=template&id=539e88a1&scoped=true"
import script from "./CCLILogo.vue?vue&type=script&lang=ts"
export * from "./CCLILogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e88a1",
  null
  
)

export default component.exports